import _ from 'lodash';
import { adminClient as apolloClient } from '@/store/apollo';

import PageGql from '@/store/graphql/cms/queries/Page.gql';
import PagesGql from '@/store/graphql/cms/queries/Pages.gql';
import ValidatePageKeyGql from '@/store/graphql/cms/queries/ValidatePageKey.gql';
// import PagesGql from '@/store/graphql/cms/queries/Pages.gql'
import PagesPaginatedGql from '@/store/graphql/cms/queries/PagesPaginated.gql';
import CreatePageGql from '@/store/graphql/cms/mutations/CreatePage.gql';
import CreatePageExtendedGql from '@/store/graphql/cms/mutations/CreatePageExtended.gql';
import UpdatePageGql from '@/store/graphql/cms/mutations/UpdatePage.gql';
import UpdatePageExtendedGql from '@/store/graphql/cms/mutations/UpdatePageExtended.gql';
import DeletePageGql from '@/store/graphql/cms/mutations/DeletePage.gql';

export default {
    validateKey: (key, categoryID = null, excludedPageID = null) =>
        new Promise((resolve, reject) => {
            let variables = { key };
            if (categoryID) variables.category = parseInt(categoryID);
            if (excludedPageID) variables.excludedPage = parseInt(excludedPageID);

            apolloClient
                .query({
                    query: ValidatePageKeyGql,
                    variables
                    // fetchPolicy: 'no-cache'
                })
                .then(({ data }) => resolve(data.CP_ValidatePageKey))
                .catch(err => reject(err));
        }),
    // fetchList: (shopID = null) => new Promise((resolve, reject) => {
    //
    //     let variables = {}
    //     if (shopID) variables.shop = shopID
    //
    //     apolloClient.query({
    //         query: PagesGql,
    //         variables
    //     })
    //         .then(({data}) => resolve(data.CP_Pages))
    //         .catch(err => reject(err))
    // }),
    fetchPagesPaginated: data =>
        new Promise((resolve, reject) => {
            let filters = [];
            _.each(data.filters, entry => filters.push(entry));

            apolloClient
                .query({
                    query: PagesPaginatedGql,
                    variables: {
                        currentPage: _.get(data, 'pageInfo.currentPage', 1),
                        perPage: _.get(data, 'pageInfo.perPage', 25),
                        order: _.get(data, 'variables.order', 'id'),
                        direction: _.get(data, 'variables.direction', 'asc'),
                        link: _.get(data, 'variables.link', '/posts/'),
                        withCategory: _.get(data, 'variables.withCategory', false),
                        scope: _.get(data, 'scope'),
                        type: _.get(data, 'type'),
                        filters
                    }
                })
                .then(({ data }) => resolve(data.CP_PagesPaginated))
                .catch(err => reject(err));
        }),
    fetchPage: (id, cmsID = null) => {
        if (id === undefined) throw new Error('required argument is missing');

        let variables = { id: parseInt(id) };
        if (cmsID) variables.cms = parseInt(cmsID);

        return new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: PageGql,
                    variables,
                    fetchPolicy: 'no-cache'
                })
                .then(({ data }) => resolve(data.CP_Page))
                .catch(err => reject(err));
        });
    },
    fetchPages: (variables) => {
        if (variables.cms) variables.cms = parseInt(variables.cms);

        return new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: PagesGql,
                    variables
                })
                .then(({ data }) => resolve(data.CP_Pages))
                .catch(err => reject(err));
        });
    },
    create: (page, extended = false) => {
        if (page === undefined) throw new Error('required argument is missing');

        page = _.removeDeepByKey(page, '__typename');
        page = _.removeDeepByKey(page, 'remote');
        page = _.removeDeepByKey(page, 'method');
        page = _.removeDeepByKey(page, 'token');
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: extended ? CreatePageExtendedGql : CreatePageGql,
                    variables: { page }
                })
                .then(async ({ data }) => {
                    await apolloClient.clearStore();
                    // NOTE: timeout -> workaround for Invariant Violation
                    await new Promise(cb => setTimeout(cb, 10));
                    resolve(data.CP_CreatePage);
                })
                .catch(err => reject(err));
        });
    },
    update: (page, extended = false) => {
        if (page === undefined) throw new Error('required argument is missing');

        page = _.removeDeepByKey(page, '__typename');
        page = _.removeDeepByKey(page, 'remote');
        page = _.removeDeepByKey(page, 'method');
        page = _.removeDeepByKey(page, 'token');
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: extended ? UpdatePageExtendedGql : UpdatePageGql,
                    variables: { page }
                })
                .then(async ({ data }) => {
                    // NOTE: timeout -> workaround for Invariant Violation
                    await apolloClient.clearStore();
                    await new Promise(cb => setTimeout(cb, 10));
                    resolve(data.CP_UpdatePage)
                })
                .catch(err => reject(err));
        });
    },
    delete: id => {
        if (id === undefined) throw new Error('required argument is missing');

        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: DeletePageGql,
                    variables: { id: parseInt(id) }
                })
                .then(async ({ data }) => {
                    // NOTE: timeout -> workaround for Invariant Violation
                    await apolloClient.clearStore();
                    await new Promise(cb => setTimeout(cb, 10));
                    resolve(data.CP_DeletePage);
                })
                .catch(err => reject(err));
        });
    }
};
